import { generateTestId } from "@client-shared";

export const setOrdersViewTestId = (identifier: string): string =>
  generateTestId("OrdersView", identifier);
